var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralInformationCamera = function SvgGeneralInformationCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.842 13.895a3.842 3.842 0 1 1-7.683.001 3.842 3.842 0 0 1 7.683 0m-1.05 0a2.792 2.792 0 1 0-5.583 0 2.792 2.792 0 0 0 5.583 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.624 21.527h14.753a2.624 2.624 0 0 0 2.625-2.625V8.89a2.624 2.624 0 0 0-2.625-2.625H4.624A2.624 2.624 0 0 0 2 8.889v10.013a2.624 2.624 0 0 0 2.625 2.625m0-1.05c-.87 0-1.575-.704-1.575-1.575V8.89c0-.87.705-1.575 1.575-1.575h14.753c.87 0 1.575.704 1.575 1.575v10.013c0 .87-.705 1.575-1.575 1.575z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.642 7.313H18.36l-.648-2.587a2.97 2.97 0 0 0-2.885-2.253H9.175a2.97 2.97 0 0 0-2.886 2.253l-.484 1.935zM7.308 4.98a1.92 1.92 0 0 1 1.867-1.457h5.651c.884 0 1.653.6 1.867 1.457l.32 1.283H6.988z"
  }))));
};
export default SvgGeneralInformationCamera;